import Model from './Model'
import ResourceVideo from './ResourceVideo'

export default class Resource extends Model {
  resource() {
    return 'resources'
  }

  videos() {
    return this.hasMany(ResourceVideo)
  }
}
